import { createReducer } from '@reduxjs/toolkit';

import { changeQuoteLineSelection } from '../actions';

export default createReducer(
  {},
  /* eslint-disable no-param-reassign */
  {
    [changeQuoteLineSelection]: (state, { payload, meta }) => {
      state[meta.quoteLineId] = payload;
    },
  },
  /* eslint-enable no-param-reassign */
);
